module.exports = __webpack_public_path__ + "img/button_qiehuan_2d_01.55f20e15.png";